import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationInvestments: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_3939_10231"
        style={{ maskType: 'alpha' }}
        width="356"
        height="229"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 .998h356v228H0v-228z"></path>
      </mask>
      <g mask="url(#mask0_3939_10231)">
        <path
          fill={colors.primary[50]}
          d="M337 161.998c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.365 71.634-160 160-160s160 71.634 160 160z"
        ></path>
        <rect
          width="59"
          height="20"
          x="72"
          y="206"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <rect
          width="59"
          height="20"
          x="72"
          y="186"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <rect
          width="59"
          height="20"
          x="143"
          y="206"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <rect
          width="59"
          height="20"
          x="143"
          y="186"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <rect
          width="59"
          height="20"
          x="153"
          y="166"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <rect
          width="59"
          height="20"
          x="153"
          y="146"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <rect
          width="59"
          height="20"
          x="220"
          y="206"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <rect
          width="59"
          height="20"
          x="220"
          y="186"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <rect
          width="59"
          height="20"
          x="230"
          y="166"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <rect
          width="59"
          height="20"
          x="230"
          y="146"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <rect
          width="59"
          height="20"
          x="221"
          y="126"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="10"
        ></rect>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M187.388 68.276L163.597 55.09c-1.495-.83-1.329-3.03.274-3.625l62.963-23.338a2 2 0 012.67 1.561L239.65 93.55c.262 1.646-1.487 2.871-2.945 2.063L217.989 85.24a.97.97 0 01-.251.97c-5.735 5.673-36.811 35.682-62.349 45.812-22.659 8.987-65.236 9.061-86.49 8.451-2.281-.066-2.612-3.264-.417-3.888 19.522-5.551 57.263-17.357 76.121-30.451 16.715-11.607 38.305-33.822 41.907-37.57a.976.976 0 01.878-.287z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M163.597 55.089l-.97 1.749.97-1.75zm23.791 13.188l-.345 1.97a2 2 0 001.315-3.72l-.97 1.75zm-23.517-16.813l.696 1.875-.696-1.875zm62.963-23.338l-.695-1.876.695 1.876zm2.67 1.561l-1.975.314 1.975-.314zM239.65 93.55l-1.975.314 1.975-.314zm-2.945 2.063l.97-1.749-.97 1.75zM217.989 85.24l.97-1.75a2 2 0 00-2.889 2.312l1.919-.562zm-.251.97l-1.406-1.422 1.406 1.422zm-62.349 45.812l.738 1.859-.738-1.859zm-86.49 8.451l-.058 1.999.058-1.999zm-.417-3.888l-.547-1.924.547 1.924zm76.121-30.451l1.14 1.642-1.14-1.642zm41.907-37.57l-1.442-1.386 1.442 1.386zm-23.883-11.725l23.792 13.188 1.939-3.499-23.791-13.188-1.94 3.499zm.549-7.25c-3.206 1.19-3.539 5.592-.549 7.25l1.94-3.499-1.391-3.75zm62.963-23.338L163.176 49.59l1.391 3.75 62.962-23.338-1.39-3.75zm5.34 3.123a4 4 0 00-5.34-3.123l1.39 3.751 3.95-.628zm10.146 63.863l-10.146-63.863-3.95.628 10.146 63.863 3.95-.628zm-5.889 4.126c2.915 1.617 6.412-.833 5.889-4.126l-3.95.628-1.939 3.498zM217.02 86.989l18.716 10.374 1.939-3.498-18.716-10.374-1.939 3.498zm2.125.643a2.97 2.97 0 00.764-2.954l-3.839 1.124a1.03 1.03 0 01.262-1.014l2.813 2.844zm-63.018 46.249c13.064-5.182 27.412-15.379 39.123-24.883 11.748-9.535 21.002-18.505 23.895-21.366l-2.813-2.844c-2.843 2.812-11.994 11.683-23.603 21.104-11.644 9.45-25.604 19.323-38.077 24.271l1.475 3.718zm-87.286 8.591c10.66.306 26.687.441 42.908-.63 16.166-1.068 32.74-3.345 44.378-7.961l-1.475-3.718c-11.022 4.371-27.065 6.624-43.166 7.688-16.047 1.059-31.936.927-42.53.623l-.115 3.998zm-.906-7.811c-2.156.613-3.094 2.567-2.912 4.287.183 1.737 1.538 3.459 3.818 3.524l.115-3.998a.235.235 0 01-.044-.005l.007.003c.008.004.019.009.03.017a.207.207 0 01.03.025.133.133 0 01.025.033c0 .001-.002-.005-.003-.018a.102.102 0 010-.031l-.003.006a.09.09 0 01-.023.025l.006-.003c.007-.003.022-.01.048-.017l-1.094-3.848zm75.527-30.17c-9.211 6.395-23.161 12.55-37.366 17.822-14.166 5.257-28.427 9.58-38.161 12.348l1.094 3.848c9.788-2.783 24.158-7.139 38.458-12.446 14.26-5.292 28.609-11.588 38.256-18.287l-2.281-3.285zm41.606-37.313c-3.624 3.771-25.08 25.838-41.606 37.313l2.281 3.285c16.906-11.739 38.63-34.102 42.209-37.826l-2.884-2.772zm2.666-.87a2.977 2.977 0 00-2.666.87l2.884 2.772c-.242.251-.59.353-.909.297l.691-3.94z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226.998a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};

export default IllustrationInvestments;
